<template>
  <div class="py-3">
    <div v-if="title" class="mb-2.5 flex items-baseline">
      <p
        :class="
          cn('ui-text-xs font-medium mr-1.5 uppercase text-white', labelClass)
        "
      >
        {{ title }}:
      </p>
    </div>
    <div class="space-y-2.5">
      <button
        v-for="item in block.materials"
        :key="item.id"
        class="flex w-full items-center border p-4 text-white ui-text-m border-white"
        :class="selectedItem?.id === item.id ? 'font-medium' : ''"
        :disabled="item.disabled"
        @click="onFilterClick(block.slug, item)"
      >
        {{ item?.currentTranslation?.title }}
        <UiIcon
          :name="
            selectedItem?.id === item.id ? 'radio-checked' : 'radio-unchecked'
          "
          class="ml-auto size-5"
          :class="selectedItem?.id === item.id ? 'text-white' : ''"
        />
      </button>
    </div>
    <SharedFieldHint :message="errorMessage" error />
    <slot name="additional" />
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";
import {
  IProductMaterialFilterEvent,
  IProductMaterialFilterProps,
  MaterialData,
} from "ecom-types";

const props = defineProps<IProductMaterialFilterProps>();

const emit = defineEmits<{
  (e: "filter", value: IProductMaterialFilterEvent): void;
}>();

const { errorMessage, setValue } = useField(props.block?.slug, undefined, {
  initialValue: props.selectedItem?.sku,
});

function onFilterClick(slug: string, item: MaterialData) {
  setValue(item.sku);
  emit("filter", { slug, item });
}
</script>
